/* Venturi Beauty: keep bundle-priced variants and their free gifts at one unit per cart.
   This is a storefront consistency guard, not a server-side checkout validation rule. */
(() => {
  const bundleVariants = new Map([
    [67730680512791, 2],
    [67730681626903, 3],
    [67730681659671, 6],
    [67730681692439, 10]
  ]);
  const giftMinimums = new Map([
    [67855378219287, 2],
    [67855378284823, 3],
    [67855378678039, 6]
  ]);

  let repairInProgress = false;
  async function normalizeBundleCart() {
    if (repairInProgress || window.venturiCartReplacementInProgress) return;
    repairInProgress = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      const bundles = cart.items.filter(item => bundleVariants.has(Number(item.id)));
      const keepBundle = bundles[0];
      const selectedBars = keepBundle ? bundleVariants.get(Number(keepBundle.id)) : 0;
      const updates = {};
      let keptFirst = false;

      for (const item of cart.items) {
        const variant = Number(item.id);
        if (bundleVariants.has(variant)) {
          if (!keptFirst) {
            keptFirst = true;
            if (item.quantity !== 1) updates[item.key] = 1;
          } else {
            updates[item.key] = 0;
          }
        } else if (giftMinimums.has(variant)) {
          const isBundleGift = String(item.properties?._venturi_bundle_gift || '') === '1';
          if (isBundleGift && selectedBars < giftMinimums.get(variant)) {
            updates[item.key] = 0;
          } else if (item.quantity > 1) {
            updates[item.key] = 1;
          }
        }
      }

      if (window.venturiCartReplacementInProgress || Object.keys(updates).length === 0) return;
      const changed = await fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!changed.ok) return;
      const normalized = await changed.json();
      if (normalized.errors) return;
      // Fetch the fresh cart sections so the discounts and subtotals are recalculated by Shopify.
      window.location.reload();
    } catch (error) {
      console.warn('Venturi bundle cart check could not complete:', error);
    } finally {
      repairInProgress = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeBundleCart, { once: true });
  } else {
    normalizeBundleCart();
  }
})();
